import { gql } from '@apollo/client'

export default gql`
  query FindClinics($name: String) {
    practices(name: $name) {
      id
      name
    }
  }
`
